module.exports = __webpack_public_path__ + "static/media/point_2.96622f1c.svg";